module.exports = __webpack_public_path__ + "static/media/404bg.14c672c2.png";